import React, { Component } from 'react';
import "./ShowLoadingV1.css"

class ShowLoading extends Component {
    constructor(props) {
        super(props);
        this.data = props;
    }

    render = () => {
        const label = this.data.label || "Cargando, por favor espere...";
        return (
            <div className="body-wrapper mw-100">
                <div className="container-fluid mw-100" style={{ margin: 0, padding: 0 }}>
                    <div className="card card-spinner">
                        <div className="spinner">
                            <div className="spinner-ring" role="status" aria-label={label}></div>
                            <p className="spinner-label">{label}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ShowLoading;
